import { jsxs, jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material/styles';
import MuiBox from '@mui/material/Box';
import { omit } from 'lodash';
import Button from '../Button/Button.js';
import '../Button/SplitButton.js';

const ActionsWrapper = styled(MuiBox, {
    shouldForwardProp: prop => !['size', 'withGhost', 'hide'].includes(prop),
}) `
  display: ${({ hide }) => (hide ? 'none' : 'flex')};
  flex-direction: row;
  width: ${({ size }) => (size === 'small' ? 'fit-content' : '100%')};
  justify-content: ${({ withGhost }) => (withGhost ? 'flex-end' : 'center')};
  margin: ${({ theme }) => theme.spacing(8, 0, 0)};
`;
const GhostContainer = styled(MuiBox) `
  display: flex;
  flex: 1;
`;
const SideButton = styled(Button, { shouldForwardProp: prop => !['withSpace'].includes(prop) }) `
  margin: ${({ theme, withSpace }) => theme.spacing(0, withSpace ? 4 : 0, 0, 0)};
`;
const Actions = ({ ghost, secondary, primary, size }) => {
    return (jsxs(ActionsWrapper, Object.assign({ className: "actionsWrapper", "data-testid": "dialog-actions", size: size, withGhost: !!ghost }, { children: [ghost && size !== 'small' && (jsx(GhostContainer, { children: jsx(SideButton, Object.assign({ variant: "ghost", size: "large", withSpace: true }, omit(ghost, 'title'), { children: ghost.title })) })), secondary && (jsx(SideButton, Object.assign({ variant: "secondary", size: "large", withSpace: !!primary }, omit(secondary, 'title'), { children: secondary.title }))), primary && (jsx(Button, Object.assign({ size: "large", "data-testid": "approve-button" }, omit(primary, 'title'), { children: primary.title })))] })));
};

export { Actions as default };
//# sourceMappingURL=Actions.js.map
